/**
 * @typedef {Object} ValidationResult
 * @property {boolean} isValid
 * @property {string?} [message]
 */

/**
 * Checks whether two passwords (user password and password confirmation) are
 * equal and not empty. 
 * @param {string} password The password the users intends to set.
 * @param {string} confirmedPassword The confirmation password the user provides.
 * @returns {boolean} Returns whether the password matches all password policy criteria.
 */
export function arePasswordsEqualAndNotEmpty(password, confirmedPassword) {
    return password?.length > 0 && confirmedPassword?.length > 0 && password === confirmedPassword
}

/**
 * Checks whether a user-set password fulfills all the password criteria defined for password creation.
 * @param {string} password The password the user intends to set.
 * @returns {ValidationResult} True, if the password fullfils the criteria, otherwise false.
 */
export function isValidPassword(password) {
    if (password === null || password === undefined || password.trim().length === 0) {
        return {
            isValid: false,
            message: "Passwort wurde nicht gesetzt."
        }
    }

    if (password.trim() !== password) {
        return {
            isValid: false,
            message: "Das Passwort darf nicht mit einem Leerzeichen beginnen oder enden."
        }
    }

    if (password.length < 8) {
        return {
            isValid: false,
            message: "Das Passwort muss mindestens 8 Zeichen lang sein."
        }
    }

    const numberOfMatches = [
        /[a-z]/,          // has lower case
        /[A-Z]/,          // has upper case
        /[0-9]/,          // has digit
        /[^a-zA-Z0-9\s]/, // has special char (Everything which is not alphanumeric or space character)
    ].filter(regex => regex.test(password)).length;


    if (numberOfMatches < 3) {
        return {
            isValid: false,
            message: "Das Passwort muss mindestens drei der folgenden vier Kriterien erfüllen: Großbuchstaben, Kleinbuchstaben, Ziffern, Sonderzeichen."
        }
    }

    return {
        isValid: true
    }

}